import { useEffect, useState } from "react";
import { getTaskApi, updateTaskApi, apiDuplicateTask, apiRemoveTask } from "../../../../services/Admin/calendar";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Grid, Box, Button, TextField } from "@mui/material";
import Container from "@mui/material/Container";
import Client from "./Client";
import Services from "./Services";
import moment from "moment";

import DatePickerMultiple from "../../../../components/Admin/Inputs/DatePickerMultiple";
import startOfDay from "date-fns/startOfDay";
import { LoadingButton } from "@mui/lab";
import LoadingProgress from "../../../../components/LoadingProgress";
import HeaderTask from "./HeaderTask";

export default function EditTask(props) {
    const [msgSuccess, setMsgSuccess] = useState(false)
    const [msgDanger, setMsgDanger] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)

    const [titleModal, setTitleModal] = useState("Crear Servicio")
    const [isNewTask, setIsNewTask] = useState(true)
    const [taskName, setTaskName] = useState(null)
    const [workerColor, setWorkerColor] = useState(null)

    const [defaultServiceValueList, setDefaultServiceValueList] = useState({})
    const [services, setServices] = useState([])

    const [defaultUserClientValueList, setDefaultUserClientValueList] = useState({})
    const [defaultUserWorkerValueList, setDefaultUserWorkerValueList] = useState({})

    const [defaultDateTask, setDefaultDateTask] = useState(props.dateTask)

    const [isClientSelect, setIsClientSelect] = useState(false)
    const [initialValues, setInitialValues] = useState(defaultValues())
    const [originalClient, setOriginalClient] = useState({})

    const [hideCreate, setHideCreate] = useState(false)
    const [availabilityBlocked, setAvailabilityBlocked] = useState(false)

    const [newDates, setNewDates] = useState([startOfDay(new Date(props.dateTask))])

    // Client
    const [listRegion, setListRegion] = useState([])
    const [listProvince, setListProvince] = useState([])
    const [listMunicipality, setListMunicipality] = useState([])
    const [listComarca, setListComarca] = useState([])
    const [listCountry, setListCountry] = useState([])
    const [clientPhone, setClientPhone] = useState("")
    const [clientEmail, setClientEmail] = useState("")

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object(validationSchema()),
        enableReinitialize: true,
        onSubmit: async (formData) => {
            setHideCreate(true)
            setMsgSuccess(false)
            setMsgDanger(null)

            // Convierte fecha a timestamp
            let startHour = new Date(`${formData.date} ${formData.startHour}`).getTime() / 1000
            let endHour = new Date(`${formData.date} ${formData.endHour}`).getTime() / 1000
            let dates = null

            if (isNewTask) {
                dates = newDates.map((item) => {
                    let day = moment.unix(item.getTime() / 1000).format("YYYY-MM-DD")
                    return {
                        startHour: new Date(`${day} ${formik.values.startHour}`).getTime() / 1000,
                        endHour: new Date(`${day} ${formik.values.endHour}`).getTime() / 1000
                    }
                })
            }

            updateTaskApi({
                ...formData,
                startHour: startHour,
                endHour: endHour,
                dates: dates,
                idRegion: formData.idRegion.id,
                idProvince: formData.idProvince.id,
                idMunicipality: formData.idMunicipality.id,
                idCountry: formData.idCountry.id,
                idComarca: formData.idComarca.id,
            }).then(resp => {
                if (resp.data.status) {
                    setMsgSuccess(true)
                    props.handleClose()
                } else {
                    setMsgDanger(resp?.data.errors)
                }
                setHideCreate(false)
                props.handleClose()
            }).catch(err => {
                setMsgDanger(err?.response?.data?.errors)
                setHideCreate(false)
            })
        },
    })

    // Llamamos a la API para obtener los datos de la tarea, si no existe devolvemos error
    // Si no hay id, creamos la tarea
    useEffect(() => {
        const timeOutId = setTimeout(() => {
            getDataTask()
        }, 500)
        return () => clearTimeout(timeOutId)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const chnageClient = () => {
        formik.values.idService = null
        setDefaultServiceValueList({})

        formik.values.price = ""

        setDefaultUserWorkerValueList(null)
        formik.values.idWorker = null
        setWorkerColor(null)
    }

    const addZero = (i) => {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    }

    const getDataTask = async () => {
        if (!props.idTask) {
            formik.values.date = defaultDateTask
            formik.values.startHour = "07:00"
            formik.values.endHour = "08:00"
            setLoading(false)
        } else {
            getTaskApi(props.idTask).then(response => {
                if (response.status) {

                    if (response.data.data.task.idClient.id) {
                        setIsClientSelect(true)
                    }

                    let startHour = new Date(response.data.data.task.startHour * 1000)
                    let endHour = new Date(response.data.data.task.endHour * 1000)

                    setInitialValues({
                        id: response.data.data.task.id,
                        idService: response.data.data.task.idService.id,
                        serviceType: response.data.data.task.idService.serviceType || null,
                        direccion: response.data.data.task.address || "",
                        idClient: response.data.data.task.idClient.id,
                        idWorker: response.data.data.task.idWorker.id,
                        serviceUnit: response.data.data.task.serviceUnit || null,

                        idRegion: response.data.data.task.idRegion || null,
                        idProvince: response.data.data.task.idProvince || null,
                        idMunicipality: response.data.data.task.idMunicipality || null,
                        idComarca: response.data.data.task.idComarca || null,
                        idCountry: response.data.data.task.idCountry || null,

                        price: response.data.data.task.price,
                        date: new Date(response.data.data.task.startHour * 1000).toISOString().split('T')[0],
                        startHour: `${addZero(startHour.getHours())}:${addZero(startHour.getMinutes())}`,
                        endHour: `${addZero(endHour.getHours())}:${addZero(endHour.getMinutes())}`,
                        observaciones: response.data.data.task.observaciones || "",
                        observacionesCliente: response.data.data.task.observacionesCliente || ""
                    })

                    setDefaultDateTask(new Date(response.data.data.task.startHour * 1000).toISOString().split('T')[0])

                    setDefaultServiceValueList(response.data.data.task.idService)
                    setDefaultServiceValueList(response.data.data.task.idService)

                    setDefaultUserClientValueList(response.data.data.task.idClient)
                    setDefaultUserWorkerValueList(response.data.data.task.idWorker)
                    setWorkerColor(response.data.data.task.idWorker?.color || "#333")
                    setTitleModal("Editar Servicio: ")
                    setTaskName(response.data.data.task.idService.name)
                    setIsNewTask(false)

                    // Client
                    setListRegion(response.data.data.task.listRegion)
                    setListProvince(response.data.data.task.listProvince)
                    setListMunicipality(response.data.data.task.listMunicipality)
                    setListComarca(response.data.data.task.listComarca)
                    setListCountry(response.data.data.task.listCountry)

                    setClientPhone(response.data.data.task.idClient.phone || "")
                    setClientEmail(response.data.data.task.idClient.email || "")

                    setLoading(false)
                } else {
                    setMsgDanger(response.errors)
                    setError(true)
                    setLoading(false)
                }
            }).catch(error => {
                console.error(error)
            })
        }
    }

    const removeBtn = () => {
        if (formik.values?.remove === "eliminar tarea") {
            apiRemoveTask(props.idTask).then(resp => {
                props.handleClose()
            })
        } else {
            setMsgDanger(["Escribe 'eliminar tarea' para poder eliminar la tarea"])
        }
    }

    const duplicateTask = async () => {
        setError(false)
        apiDuplicateTask(props.idTask).then(resp => {
            if (resp.data.status) {
                props.handleClose()
            } else {
                setMsgDanger(resp.data?.errors)
                setError(true)
            }
        }).catch(err => {
            setMsgDanger(err?.response?.data?.errors)
            setError(true)
        })
    }

    return (
        <>
            <Container
                maxWidth="lg"
            >
                <form onSubmit={formik.handleSubmit} className="mt-2">
                    <HeaderTask
                        workerColor={workerColor}
                        error={error}
                        titleModal={titleModal}
                        taskName={taskName}
                        handleClose={props.handleClose}
                    />

                    {loading ? (
                        <LoadingProgress loading={loading} />
                    ) : (
                        <>
                            <Box border={1} className="p-20 box-default">
                                <Grid container spacing={3}>
                                    {isNewTask ? (
                                        <Grid item md={6}>
                                            <DatePickerMultiple
                                                name="dates"
                                                values={newDates}
                                                setValues={setNewDates}
                                            />
                                        </Grid>
                                    ) : (
                                        <Grid item md={6}>
                                            <TextField
                                                name="date"
                                                label="Día"
                                                variant="outlined"
                                                type="date"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={(e) => {
                                                    formik.values.date = e.target.value
                                                    setDefaultDateTask(e.target.value)

                                                }}
                                                value={defaultDateTask}
                                                // className={classes.textField}
                                                InputLabelProps={{ shrink: true }}
                                                size="small"
                                            />


                                            {formik.errors.date && (
                                                <p className="text-100 text-danger mt-1">
                                                    {formik.errors.date}
                                                </p>
                                            )}
                                        </Grid>
                                    )}

                                    <Grid item md={3}>
                                        <TextField
                                            name="startHour"
                                            label="* Hora Inicio"
                                            variant="outlined"
                                            type="time"
                                            fullWidth
                                            format="HH:mm"
                                            value={formik.values.startHour}
                                            onChange={formik.handleChange}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                step: 60, // 1 min
                                            }}
                                            size="small"
                                        />
                                        {formik.errors.startHour && (
                                            <p className="text-100 text-danger mt-1">
                                                {formik.errors.startHour}
                                            </p>
                                        )}
                                    </Grid>
                                    <Grid item md={3}>
                                        <TextField
                                            name="endHour"
                                            variant="outlined"
                                            label="* Hora Finalización"
                                            type="time"
                                            fullWidth
                                            value={formik.values.endHour}
                                            onChange={formik.handleChange}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{
                                                step: 60, // 1 min
                                            }}
                                            size="small"
                                        />
                                        {formik.errors.endHour && (
                                            <p className="text-100 text-danger mt-1">
                                                {formik.errors.endHour}
                                            </p>
                                        )}
                                    </Grid>
                                </Grid>
                            </Box>

                            <Grid container spacing={3}>
                                <Grid item xs={12} md={6} lg={6}>
                                    <Client
                                        defaultUserClientValueList={defaultUserClientValueList}
                                        setDefaultUserClientValueList={setDefaultUserClientValueList}
                                        formik={formik}
                                        isClientSelect={isClientSelect}
                                        setIsClientSelect={setIsClientSelect}
                                        setOriginalClient={setOriginalClient}
                                        chnageClient={chnageClient}
                                        setServices={setServices}

                                        listRegion={listRegion}
                                        setListRegion={setListRegion}
                                        listProvince={listProvince}
                                        setListProvince={setListProvince}
                                        listMunicipality={listMunicipality}
                                        setListMunicipality={setListMunicipality}
                                        listComarca={listComarca}
                                        setListComarca={setListComarca}
                                        listCountry={listCountry}
                                        setListCountry={setListCountry}

                                        clientPhone={clientPhone}
                                        setClientPhone={setClientPhone}
                                        clientEmail={clientEmail}
                                        setClientEmail={setClientEmail}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6} lg={6}>
                                    <Services
                                        formik={formik}
                                        isClientSelect={isClientSelect}
                                        defaultUserWorkerValueList={defaultUserWorkerValueList}
                                        originalClient={originalClient}
                                        setDefaultServiceValueList={setDefaultServiceValueList}
                                        defaultServiceValueList={defaultServiceValueList}
                                        setDefaultUserWorkerValueList={setDefaultUserWorkerValueList}
                                        services={services}
                                        idTask={props.idTask}
                                        isNewTask={isNewTask}
                                        newDates={newDates}
                                        onAvailabilityBlockedChange={setAvailabilityBlocked}
                                    />
                                </Grid>

                            </Grid>

                            {!isNewTask && (
                                <Box border={1} className="p-20 mt-2 box-default">
                                    <Grid container spacing={3}>
                                        <Grid item md={12}>
                                            <h5 className="p-0 mt-0">Ajustes</h5>
                                            <p>
                                                Identificador interno de la tarea.
                                            </p>
                                            <p>
                                                Pulsa el botón "DUPLICAR TAREA" y se creará una tarea con las mismas
                                                especificaciones que esta, si has realizado alguna modificación guarda antes de
                                                duplicar.
                                            </p>
                                            <p>
                                                Para poder eliminar la tarea, escriba "eliminar tarea" y pulsé el botón ELIMINAR
                                            </p>
                                        </Grid>
                                        <Grid item md={3}>
                                            <TextField
                                                variant="outlined"
                                                label="* Identificador de la tarea"
                                                className="form-control"
                                                name="name"
                                                type="text"
                                                value={formik.values.id}
                                                onChange={formik.handleChange}
                                                disabled
                                                fullWidth
                                                size="small"
                                            />
                                        </Grid>

                                        <Grid item md={3}>
                                            <Button
                                                onClick={duplicateTask}
                                                type="button"
                                                variant="contained"
                                                className="MuiButton-containedCancel"
                                                fullWidth
                                            >
                                                Duplicar Tarea
                                            </Button>
                                        </Grid>
                                        {/* <Grid item md={12}></Grid> */}
                                        <Grid item md={6}>
                                            <Grid container spacing={3}>
                                                <Grid item xs={6} md={6} lg={6}>
                                                    <TextField
                                                        value={formik.values.remove}
                                                        onChange={formik.handleChange}
                                                        variant="outlined"
                                                        label="Eliminar (eliminar tarea)"
                                                        className="form-control"
                                                        placeholder="eliminar tarea"
                                                        name="remove"
                                                        type="text"
                                                        fullWidth
                                                        size="small"
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                </Grid>
                                                <Grid item xs={6} md={6} lg={6}>
                                                    <Button
                                                        onClick={removeBtn}
                                                        type="button"
                                                        variant="contained"
                                                        className="MuiButton-containedCancel"
                                                        fullWidth
                                                    >
                                                        Eliminar
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )}

                            <Grid container spacing={3} className="p-20">

                                {msgSuccess && (
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Box className="alert-success">
                                            Los datos de la tarea se han guardado correctamente
                                        </Box>
                                    </Grid>
                                )}

                                {msgDanger && (
                                    <Grid item xs={12} md={12} lg={12}>
                                        <Box className="alert-danger">
                                            {msgDanger.map((item, index) => {
                                                return (<span key={index}>{item}<br /></span>)
                                            })}
                                        </Box>
                                    </Grid>
                                )}

                                <Grid item md={12}>
                                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <div style={{ width: 200 }}>
                                            {props.parent === "calendario" ? (
                                                <Button
                                                    href="/dash-admin/calendario/management"
                                                    type="button"
                                                    variant="contained"
                                                    className="MuiButton-containedCancel"
                                                    fullWidth
                                                >
                                                    Cerrar
                                                </Button>
                                            ) : (
                                                <Button
                                                    href="/dash-admin/trabajos/management"
                                                    type="button"
                                                    fullWidth
                                                    variant="contained"
                                                    className="MuiButton-containedCancel"
                                                >
                                                    Cerrar
                                                </Button>
                                            )}
                                        </div>

                                        <div style={{ width: 200, marginLeft: 20 }}>
                                            <LoadingButton
                                                type="submit"
                                                loading={hideCreate}
                                                disabled={availabilityBlocked}
                                                loadingPosition="start"
                                                variant="contained"
                                                fullWidth
                                            >
                                                Guardar
                                            </LoadingButton>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </>
                    )}

                </form>
            </Container>
        </>
    )

}

function defaultValues() {
    return {
        id: "",
        idClient: "",
        idWorker: "",
        direccion: "",
        observacionesCliente: "",
        idService: "",
        idRegion: "",
        idProvince: "",
        idMunicipality: "",
        date: "",
        startHour: "07:00",
        endHour: "08:00",
        price: "",
        remove: "",
        serviceType: null,
    }
}

function validationSchema() {
    return {
        idClient: Yup.number().typeError('El cliente es obligatorio').required("El cliente es obligatorio"),
        idWorker: Yup.number().typeError('El trabajador es obligatorio').required("El trabajador es obligatorio"),
        idService: Yup.number().typeError('El tipo de servicio es obligatorio').required("El tipo de servicio es obligatorio"),
        idRegion: Yup.object().typeError('La comunidad es obligatoria').required("La comunidad es obligatoria"),
        idProvince: Yup.object().typeError('La provincia es obligatoria').required("La provincia es obligatoria"),
        idMunicipality: Yup.object().typeError('La población es obligatoria').required("La población es obligatoria"),
        idComarca: Yup.object().typeError('La comarca es obligatoria').required("La comarca es obligatoria"),
        idCountry: Yup.object().typeError('El país es obligatorio').required("El país es obligatorio"),
    }
}
